import { readable, derived } from 'svelte/store';

export function ycOnboardingTriggerLocation() {
  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycOnboardingTriggerLocation) {
    console.log('CALLING: window.webkit.messageHandlers.ycOnboardingTriggerLocation.postMessage({})');
    window.webkit.messageHandlers.ycOnboardingTriggerLocation.postMessage({});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycOnboardingTriggerLocation) {
    console.log('CALLING: window.YinzNativeApplication.ycOnboardingTriggerLocation()');
    window.YinzNativeApplication.ycOnboardingTriggerLocation();
  } else {
    console.log('Unable to call ycOnboardingTriggerLocation: no message handler found.')
  }
}

export function ycOnboardingTriggerNotification(tags) {
  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycOnboardingTriggerNotification) {
    console.log('CALLING: window.webkit.messageHandlers.ycOnboardingTriggerNotification.postMessage({tags: tags})');
    window.webkit.messageHandlers.ycOnboardingTriggerNotification.postMessage({tags: tags});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycOnboardingTriggerNotification) {
    console.log('window.YinzNativeApplication.ycOnboardingTriggerNotification(tags)');
    window.YinzNativeApplication.ycOnboardingTriggerNotification(tags);
  } else {
    console.log('Unable to call ycOnboardingTriggerNotification: no message handler found.')
  }
}

export function ycOnboardingTriggerMicrophone() {
  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycOnboardingTriggerMicrophone) {
    console.log('CALLING: window.webkit.messageHandlers.ycOnboardingTriggerMicrophone.postMessage({})');
    window.webkit.messageHandlers.ycOnboardingTriggerMicrophone.postMessage({});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycOnboardingTriggerMicrophone) {
    console.log('CALLING: window.YinzNativeApplication.ycOnboardingTriggerMicrophone()');
    window.YinzNativeApplication.ycOnboardingTriggerMicrophone();
  } else {
    console.log('Unable to call ycOnboardingTriggerMicrophone: no message handler found.')
  }
}

export function ycSSOThirdParty(type) {
  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycSSOThirdParty) {
    window.webkit.messageHandlers.ycSSOThirdParty.postMessage({type: type});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycSSOThirdParty) {
    window.YinzNativeApplication.ycSSOThirdParty(type);
  } else {
    console.log('Unable to call ycSSOThirdParty: no message handler found.')
  }
}

export function ycSSOStoreTicket(yinzID, accountCreated, yticket, yvalidSpan) {
  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycSSOStoreTicket) {
    window.webkit.messageHandlers.ycSSOStoreTicket.postMessage({yinzID: yinzID, accountCreated: accountCreated, yticket: yticket, yvalidSpan: yvalidSpan, lvalidSpanString: null, ltoken: null});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycSSOStoreTicket) {
    window.YinzNativeApplication.ycSSOStoreTicket(yinzID, accountCreated, yticket, yvalidSpan, null, null);
  } else {
    console.log('Unable to call ycSSOStoreTicket: no message handler found.')
  }
}

export function ycSSOAuthFinished(success) {
  if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.ycSSOAuthFinished) {
    window.webkit.messageHandlers.ycSSOAuthFinished.postMessage({success: success});
  } else if (window.YinzNativeApplication && window.YinzNativeApplication.ycSSOStoreTicket) {
    window.YinzNativeApplication.ycSSOAuthFinished(success);
  } else {
    console.log('Unable to call ycSSOAuthFinished: no message handler found.')
  }
}

// onboarding callbacks
/*
window.ycOnboardingPermissionUpdate = function(type, value) {
  window.localStorage.setItem('yc-onboarding-permission-' + type, value);
  document.dispatchEvent(new Event('yc-onboarding-permission-' + type));
};
*/

// TODO, move this elsewhere?
window.ycSSOThirdPartyCallback = function(type, json) {
  //console.log(json);
  ycSSOAuthFinished(true);
};

export const ycTicket = readable({ticket: null, validSpan: null}, function start(set) {
  window.setHubValidTicket = function(ticket, validSpan) {
    console.log('Set ticket callback from app');
    if (typeof validSpan === 'string') {
      validSpan = parseInt(validSpan)
    }
    set({ticket, validSpan});
  };
  //window.setHubValidTicket('Y662Kkl6TAuA+pQiSlU91QAAAXwoaVZUOhBeT+EChJH/giKJWAaT9UJFdhcU5ZxUxOkDxHFC4npxF0EpSpz19LXOoc3VXQpSONkf8rd6XSxOyjFGhCehsauEpLzArDZzEniCnHwH3/g7jXCi8B+hOn7nFJZnman+', 31536000000);
  if (/(iPhone|iPod|iPad)/i.test(navigator.userAgent)) {
    console.log('Set ticket for iOS');
    // iOS will pass the ticket automatically
    // for testing
    //setTimeout(() => window.setHubValidTicket('lBUzg5+WQMiHaezezUtwjQAAAXZJNC+zFSFWFOk4syTD/fnnx9Hi10DDIQ6X+qCHbN6f9femcotrfoHcey/zBxBkgYR6vT9QQfoWdvG832bU6Z6ZkbUb/rUDh71lPuhKtX6/e/+h4AKXlqzxhGjadodZQxEDhdF0', 31536000000), 500);
  } else if (typeof window.YinzNativeApplication != 'undefined') {
    console.log('Set ticket for ANDROID');
    window.YinzNativeApplication.getAppValidTicket();
  } else {
    // for testing
    console.log('Set ticket for WEB (testing)');

    // nathan+5 (ANSWERED)
    //window.setHubValidTicket('9eGOhAqATYmIeF9/SWrMNAAAAXt/QE6KuktQ9VX2GQvQfhh0rR8KP7r3+8+EfAZaFEtnz9yCNFL38RxxvwDeSFh+TidOwwvqn8N2gjmnMfrV6rhZ/MXwUjUSx8UhbGqZOtiX/XlLak7De2jP/tSORvRAtP4CRlaP', 31536000000);

    // nathan+7 (NOT ANSWERED)
    //window.setHubValidTicket('Y662Kkl6TAuA+pQiSlU91QAAAXwoaVZUOhBeT+EChJH/giKJWAaT9UJFdhcU5ZxUxOkDxHFC4npxF0EpSpz19LXOoc3VXQpSONkf8rd6XSxOyjFGhCehsauEpLzArDZzEniCnHwH3/g7jXCi8B+hOn7nFJZnman+', 31536000000);

    // nathan+10 (ANSWERED)
    //window.setHubValidTicket('TfPAGRg/Q5CkWMrQh7vOvwAAAZp9XIhnm/ngQRTBjtf9dUH9WJerS6CuKuEasjQnalMNOTzNUDSeiJPumGnFegFdQ2kQp3Ogu/MsQ9F8VWFs3BpzC1Z7SOzTDYAqS8/5GIN7wsBlTClnRHWG/ZJgmm7wq3kYCzyu', 31536000000);
  }

  //window.setHubValidTicket('TfPAGRg/Q5CkWMrQh7vOvwAAAZp9XIhnm/ngQRTBjtf9dUH9WJerS6CuKuEasjQnalMNOTzNUDSeiJPumGnFegFdQ2kQp3Ogu/MsQ9F8VWFs3BpzC1Z7SOzTDYAqS8/5GIN7wsBlTClnRHWG/ZJgmm7wq3kYCzyu', 31536000000);

  function stopHandler() {
    window.setHubValidTicket = () => {};
  }
  return stopHandler;
});